<template>
  <Modal v-model="warehouseModal" :title="warehouseModalTitle" width="800" class-name="warehouseStyle"
    :transfer="false" :mask-closable="false" @on-visible-change="warehouseModalChange">
    <Form ref="warehouseForm" :model="warehouseForm" :rules="ruleValidate" :label-width="labelWidth"
      :disabled="warehouseType === 'look'" @submit.native.prevent>
      <!--基本信息-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)">
                    <Input clearable v-model.trim="warehouseForm['name_' + item.code]" :disabled="warehouseType !== 'add' && item.code === 'zh-CN'"></Input>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
          <Divider style="margin: 0 0 24px 0;"/>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002352')" prop="code">
              <Input clearable v-model.trim="warehouseForm.code" :placeholder="$t('key1000324')" :disabled="warehouseType !=='add'"></Input>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002354')" prop="warehouseType">
              <Select v-model="warehouseForm.warehouseType" filterable
                :disabled="warehouseType !=='add' || ymsThreeWarehouseSetList.length <=0">
                <Option v-for="(item, index) in warehouseTypeData" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1001522')" prop="status">
              <Select v-model="warehouseForm.status" filterable>
                <Option v-for="(item, index) in statusList" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002433')" prop="ymsDeliveryPlaceId">
              <Select v-model="warehouseForm.ymsDeliveryPlaceId" :disabled="warehouseDisabled"
                filterable @on-change="warehouseDeliveryPlaceChange">
                <Option v-for="(item, index) in placeOfShipmentList" :value="item.ymsDeliveryPlaceId" :key="index">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <Form-item :label="$t('key1002434')" prop="stockedWarehouse" class="radio_styles">
              <RadioGroup v-model="warehouseForm.stockedWarehouse">
                <Radio :label="1">{{ $t('key1000392') }}</Radio>
                <Radio :label="0">{{ $t('key1000393') }}</Radio>
              </RadioGroup>
            </Form-item>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="allowCollectGoodsTalg">
            <Form-item :label="$t('key1002435')" prop="collectionWarehouse" class="radio_styles">
              <RadioGroup v-model="warehouseForm.collectionWarehouse">
                <Radio :label="1">{{ $t('key1000392') }}</Radio>
                <Radio :label="0">{{ $t('key1000393') }}</Radio>
              </RadioGroup>
            </Form-item>
          </Col>
        </Row>
      </Card>
      <!--海外仓配置模块-->
      <overseasWarehouseConfigModule
        ref="overseasWarehouseConfig"
        :warehouseOptionType="warehouseType"
        :warehouseType="warehouseForm.warehouseType"
        :thirdPartyWarehouseList="thirdPartyWarehouseList"
        :countryOfDeliveryList="countryOfDeliveryList">
      </overseasWarehouseConfigModule>
      <!--仓库发货、收货、退货地址-->
      <Card :bordered="false" dis-hover v-for="(item,index) in addressData" :key="index">
        <template #title>
          <h2 class="title_box">{{ item.title }}</h2>
        </template>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002436')" :prop="item.addressType +  '.ymsAddressTemplateId'"
              :rules="{required: true, message: $t('key1002432'),trigger: 'change'}">
              <div class="flex align-items-center">
                <Select
                  @on-change="(val)=>selectChange(val, item.addressType)"
                  @on-open-change="openChange"
                  v-model="warehouseForm[item.addressType].ymsAddressTemplateId"
                  filterable
                  style="width: 250px;">
                  <Option v-for="(ele, index) in (item.addressType === 'sender' ? senderAddressTemplateData : addressTemplateList)"
                    :value="ele.ymsAddressTemplateId" :label="ele.addressName" :key="index">
                    <span v-html="ele.templateName"></span>
                  </Option>
                </Select>
                <span class="cursor themeColor ml8 font-size-13" v-if="warehouseType !== 'look'" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
              </div>
            </Form-item>
          </Col>
        </Row>
        <Row type="flex" :gutter="gutterItem" class="basic_information_box pl62 font-size-12" v-if="Object.keys(item.addressDetails).length >0">
          <Col :span="12" class="basic_item" v-for="ele in addressInfoList">
            <span class="basic_title">{{ ele.title + '：' }}</span>
            <span class="basic_txt" :title="item.addressDetails[ele.paramsKey]">{{ item.addressDetails[ele.paramsKey] || '--' }}</span>
          </Col>
        </Row>
      </Card>
      <!--仓库处理费-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002445') }}</h2>
        </template>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="layeredPriceList.length <=0">
            <Form-item :label="$t('key1002437')" prop="packageHandlerCost">
              <div class="flex align-items-center">
                <InputNumber
                  :min="0"
                  :max="99999999"
                  style="width: 300px;"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="warehouseForm.packageHandlerCost">
                </InputNumber>
                <span class="ml6">{{ currencyState + $t('key1002442') }}</span>
              </div>
              <span class="themeColor cursor mt2 font-size-12" v-if="warehouseType !== 'look'" @click="addTieredPricingBtn">{{ $t('key1002446') }}</span>
            </Form-item>
          </Col>
          <!--分层价-->
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="layeredPriceList.length >0">
            <Form-item :label="$t('key1002437')" class="required_style_label">
              <div style="position: relative;top: 3px;">
                <div v-for="(item,index) in layeredPriceList" class="flex align-items-center mb24" :class="index >0 ? 'ml30': ''" style="position: relative;">
                  <span class="font-size-12 mr6" v-if="index === 0">{{ $t('key1002447') }}</span>
                  <Form-item :class="(item.startErrorText || item.errorText) && !item.disabled ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      :disabled="item.disabled"
                      :min="0"
                      :max="99999999"
                      style="width: 120px;"
                      v-model.trim="item.start"
                      @on-blur="verificationInterval(item, index, 'left')"
                      :formatter="(value) => parseInt(value)">
                    </InputNumber>
                    <span v-if="item.startErrorText && !item.disabled" class="font-size-12 redColor errorTxt">{{ item.startErrorText }}</span>
                  </Form-item>
                  <span class="font-size-12 ml8 mr8">{{ $t('key1000828') }}</span>
                  <Input :disabled="true" style="width: 120px;" v-if="index === layeredPriceList.length - 1" v-model.trim="infinite"></Input>
                  <Form-item v-else :class="item.endErrorText || item.errorText ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      :min="0"
                      :max="99999999"
                      style="width: 120px;"
                      v-model.trim="item.end"
                      @on-blur="blurEndInput(item, index)"
                      :formatter="(value) => parseInt(value)">
                    </InputNumber>
                    <span v-if="item.endErrorText" class="font-size-12 redColor errorTxt">{{ item.endErrorText }}</span>
                  </Form-item>
                  <span class="font-size-12 ml6 mr6">{{ $t('key1002448') }}</span>
                  <Form-item :class="item.priceText ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      :min="0"
                      :max="99999999"
                      style="width: 120px;"
                      v-model.trim="item.packageHandlerCost"
                      :formatter="(value) => formatterNumber(value, 2)"
                      @on-blur="verificationInterval(item, index, 'price')">
                    </InputNumber>
                    <span v-if="item.priceText" class="font-size-12 redColor errorTxt">{{ item.priceText }}</span>
                  </Form-item>
                  <span class="ml6 mr6 font-size-12">{{ currencyState + $t('key1002442') }}</span>
                  <Icon type="ios-trash" color="rgb(225 31 18)" class="cursor" v-if="index>0 && warehouseType !== 'look'"
                    size="24" @click="deleteLayeredPriceBtn(item, index)"/>
                  <span v-if="item.errorText" class="font-size-12 redColor errorStyles"
                    :style="index === 0 ? {left: '30px'}: ''">
                    {{ item.errorText }}
                  </span>
                </div>
              </div>
              <span class="themeColor cursor mt2 font-size-12" v-if="warehouseType !== 'look'" @click="addTieredPricingBtn">{{ $t('key1002446') }}</span>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002438')" prop="addPackageHandlerCost">
              <div class="flex align-items-center">
                <InputNumber
                  :min="0"
                  :max="99999999"
                  style="width: 300px;"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="warehouseForm.addPackageHandlerCost">
                </InputNumber>
                <span class="ml6 font-size-12">{{ currencyState + $t('key1002442') }}</span>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002439')" prop="packageMaterialCost">
              <div class="flex align-items-center">
                <InputNumber
                  :min="0"
                  :max="99999999"
                  style="width: 300px;"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="warehouseForm.packageMaterialCost">
                </InputNumber>
                <span class="ml6 font-size-12">{{ currencyState + $t('key1002443') }}</span>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002440')" prop="addPurchaseStockCost">
              <div class="flex align-items-center">
                <InputNumber
                  :min="0"
                  :max="99999999"
                  style="width: 300px;"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="warehouseForm.addPurchaseStockCost">
                </InputNumber>
                <span class="ml6 font-size-12">{{ currencyState + $t('key1002442') }}</span>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002441')" prop="warehouseCost">
              <div class="flex align-items-center">
                <InputNumber
                  :min="0"
                  :max="99999999"
                  style="width: 300px;"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="warehouseForm.warehouseCost">
                </InputNumber>
                <span class="ml6 font-size-12">{{ currencyState + $t('key1002444') }}</span>
              </div>
            </Form-item>
          </Col>
        </Row>
      </Card>
    </Form>
    <template #footer>
      <Button @click="warehouseModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="warehouseBtn" v-if="warehouseType !== 'look'">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import languagesTabs from "@/components/common/languagesTabs";
import overseasWarehouseConfigModule from "@/views/yms/components/basicSettings/overseasWarehouseConfigModule.vue";
import {isValueEmpty, formatterNumber, getDeliveryAreasAllData} from "@/utils/common";

export default {
  name: "warehouseModal",
  mixins: [Mixin],
  props: {
    warehouseTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    countrysOriginalData: {
      type: Array,
      default: () => []
    },
    ymsThreeWarehouseSetList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      ymsWarehouseId: null,
      statusList: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
      ],
      warehouseModal: false,
      warehouseType: 'add',
      warehouseModalTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002414'),
      warehouseForm: {
        code: '', // 仓库编码
        warehouseType: 1, // 仓库类型
        status: null, // 仓库状态
        ymsDeliveryPlaceId: null, // 发货地
        stockedWarehouse: 1, // 是否能备货
        collectionWarehouse: 0,// 是否设置为集货仓
        sender: {
          ymsAddressTemplateId: null,
          ymsWarehouseAddressId: null
        },
        pickup: {
          ymsAddressTemplateId: null,
          ymsWarehouseAddressId: null
        },
        return: {
          ymsAddressTemplateId: null,
          ymsWarehouseAddressId: null
        },
        packageHandlerCost: null, // 常规订单处理费
        addPackageHandlerCost: null, // 常规多品订单续件
        packageMaterialCost: null, // 常规订单耗材费
        addPurchaseStockCost: null, // 备货类订单处理费
        warehouseCost: null, // 仓库租金
      },
      ruleValidate: {
        code: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002415'), trigger: 'blur'}
        ],
        warehouseType: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002416'), trigger: 'change'}
        ],
        status: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002319'), trigger: 'change'}
        ],
        ymsDeliveryPlaceId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002417'), trigger: 'change'}
        ],
        packageHandlerCost: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002418'), trigger: 'change'}
        ],
        addPackageHandlerCost: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002419'), trigger: 'change'}
        ],
        addPurchaseStockCost: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002420'), trigger: 'change'}
        ],
      },
      addressData: [
        {
          addressType: 'sender',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002421'),
          addressDetails: {}
        },
        {
          addressType: 'pickup',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002422'),
          addressDetails: {}
        },
        {
          addressType: 'return',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002423'),
          addressDetails: {}
        },
      ],
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCodeName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      layeredPriceList: [],
      infinite: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000836'),
      placeOfShipmentList: [],
      allowCollectGoodsTalg: false,
      senderAddressTemplateData: [],
      addressTemplateList: [],
      thirdPartyWarehouseList: [],
      warehouseTypeData: [],
    }
  },
  computed: {
    // 获取当前发货地所在的国家code值
    countryOfDeliveryList() {
      const ymsDeliveryPlaceId = this.warehouseForm?.ymsDeliveryPlaceId;
      const place = this.placeOfShipmentList?.find(v => v.ymsDeliveryPlaceId === ymsDeliveryPlaceId);
      return [...new Set((place?.ymsDeliveryPlaceCountryList || []).map(c => c.deliveryCountry))];
    },
    // 第三方仓库编辑禁用标识
    warehouseDisabled() {
      return ['look', 'edit'].includes(this.warehouseType) && this.warehouseForm.warehouseType === 2;
    }
  },
  methods: {
    formatterNumber,
    // 初始化仓库
    initWarehouse(type, ymsWarehouseId) {
      let v = this;
      if (v.ymsThreeWarehouseSetList.length <= 0) {
        v.warehouseTypeData = v.warehouseTypeList.filter((item) => {
          return item.value !== 2;
        })
      } else {
        v.warehouseTypeData = v.warehouseTypeList;
      }
      v.initMultilingualFields('warehouseForm', v.warehouseForm, ['name_']);
      v.$nextTick(() => {
        v.$refs['languagesTab'].tabName = v.languagesVal;
      });
      v.warehouseType = type;
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002414'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002425'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002426')
      };
      v.warehouseModalTitle = titleObj[type];
      (async () => {
        await getDeliveryAreasAllData().then((data) => {
          v.placeOfShipmentList = data;
        });
        await v.getCarrierInfo().then((data) => {
          v.thirdPartyWarehouseList = data.filter((item) => {
            return v.ymsThreeWarehouseSetList.includes(item.carrierCode)
          });
        });
        await v.getAddressTemplateData().then((data) => {
          v.addressTemplateList = data;
        });
        if (type !== 'add') {
          await v.getWarehouseDetails(ymsWarehouseId)
        } else {
          v.$nextTick(() => {
            v.$refs['warehouseForm'].resetFields();
          });
          v.$refs['overseasWarehouseConfig'].initOverseasWarehouseConfigData();
          v.warehouseModal = true;
        }
      })();
    },
    // 获取仓库基本信息
    getWarehouseDetails(ymsWarehouseId) {
      this.ymsWarehouseId = ymsWarehouseId;
      this.axios.get(api.get_ymsWarehouse + ymsWarehouseId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let keyBasicList = ['code', 'status', 'warehouseType', 'ymsDeliveryPlaceId', 'stockedWarehouse', 'collectionWarehouse'];
          if (data) {
            // 地址
            let ymsWarehouseAddress = data.ymsWarehouseAddress || [];
            if (ymsWarehouseAddress.length > 0) {
              ymsWarehouseAddress.map((item) => {
                this.warehouseForm[item.addressType].ymsWarehouseAddressId = item.ymsWarehouseAddressId;
                if (item.ymsAddressTemplateId) {
                  this.selectChange(item.ymsAddressTemplateId, item.addressType);
                  this.warehouseForm[item.addressType].ymsAddressTemplateId = item.ymsAddressTemplateId;
                }
              });
            }
            // 处理费
            if (data.ymsWarehousePriceModels && data.ymsWarehousePriceModels.length > 0) {
              let keyList = ['packageHandlerCost', 'addPackageHandlerCost', 'packageMaterialCost', 'addPurchaseStockCost', 'warehouseCost'];
              if (data.ymsWarehousePriceModels[0].ymsWarehousePriceModelDetails) {
                let obj = data.ymsWarehousePriceModels[0].ymsWarehousePriceModelDetails[0];
                if (obj) {
                  keyList.map((key) => {
                    this.warehouseForm[key] = obj[key];
                  });
                  let newList = obj.ymsWarehousePriceModelDetailRules || [];
                  if (newList.length > 0) {
                    newList.map((item, index) => {
                      if (index !== 0) {
                        item.disabled = true;
                      }
                    });
                    this.layeredPriceList = newList;
                  }
                }
              }
            }
            keyBasicList.map((key) => {
              this.warehouseForm[key] = data[key];
            });
            if (this.warehouseForm.ymsDeliveryPlaceId) {
              this.warehouseDeliveryPlaceChange(this.warehouseForm.ymsDeliveryPlaceId, this.warehouseForm.collectionWarehouse, true);
            }
            let obj = this.handleMultilingualFormFields(data, ['name']);
            this.warehouseForm = Object.assign({}, this.warehouseForm, obj);
            this.$refs['overseasWarehouseConfig'].initOverseasWarehouseConfigData(data);
          }
          this.$forceUpdate();
          this.warehouseModal = true;
        }
      });
    },
    // 新增、编辑仓库弹窗的确定按钮
    warehouseBtn() {
      let v = this;
      let talg = true;
      let url = '';
      let method = 'post';
      let text = '';
      let validateField = [
        'code',
        'warehouseType',
        'status',
        'ymsDeliveryPlaceId',
        'packageHandlerCost',
        'addPackageHandlerCost',
        'addPurchaseStockCost',
        'name_' + v.languagesVal,
        'sender.ymsAddressTemplateId',
        'pickup.ymsAddressTemplateId',
        'return.ymsAddressTemplateId'
      ];
      let obj = JSON.parse(JSON.stringify(v.warehouseForm));

      // 处理地址的参数
      function handleAddress(item) {
        let list = [];
        let keyList = ['sender', 'pickup', 'return'];
        keyList.map((key) => {
          let obj = {
            ymsAddressTemplateId: item[key].ymsAddressTemplateId,
            addressType: key
          }
          if (item[key].ymsWarehouseAddressId) {
            obj.ymsWarehouseAddressId = item[key].ymsWarehouseAddressId;
          }
          list.push(obj);
        });
        return list;
      }

      let newList = [];

      // 校验分层价的数据
      if (v.layeredPriceList.length > 0) {
        let keyList = ['left', 'right', 'price'];
        v.layeredPriceList.map((item, index) => {
          keyList.map((key) => {
            v.verificationInterval(item, index, key);
          });
          newList.push({
            end: item.end,
            packageHandlerCost: item.packageHandlerCost,
            start: item.start,
            type: 1
          })
        });
        talg = v.layeredPriceList.every((ele) => {
          return !ele.startErrorText && !ele.endErrorText && !ele.priceText && !ele.errorText
        });
        validateField = validateField.filter((key) => {
          return key !== 'packageHandlerCost'
        });
      }

      let parameter = {
        code: obj.code,
        name: v.handleMultilingualSingleParam(obj, 'name_'),
        status: obj.status,
        warehouseType: obj.warehouseType,
        ymsDeliveryPlaceId: obj.ymsDeliveryPlaceId,
        stockedWarehouse: obj.stockedWarehouse,
        collectionWarehouse: obj.collectionWarehouse,
        ymsWarehouseAddressBos: handleAddress(obj),
        ymsWarehousePriceModelBos: [
          {
            type: 2, // 费用类型  1包裹处理费 2仓库处理费
            billingType: v.layeredPriceList.length <= 0 ? 1 : 2, //  计费方式 1固定计费/件 2分层计费
            ymsWarehousePriceModelDetailBos: [
              {
                packageHandlerCost: v.layeredPriceList.length <= 0 ? obj.packageHandlerCost : null,
                addPackageHandlerCost: obj.addPackageHandlerCost,
                billingType: 1, // 计费类型  1首续收费
                addPurchaseStockCost: obj.addPurchaseStockCost,
                packageMaterialCost: obj.packageMaterialCost,
                warehouseCost: obj.warehouseCost,
                ymsWarehousePriceModelDetailRuleBos: newList
              }
            ]
          }
        ],
        apiWarehouseCode: null,
        apiWarehouseId: null,
        apiWarehouseName: null,
        apiInterface: null,
        carrierCode: null,
        systemShippingMethodIds: [], // 启用的三方物流渠道
        carrierShippingMethodWarehouses: [], // 适用仓库的物流渠道
      }
      let params = v.$refs['overseasWarehouseConfig'].getOverseasWarehouseConfig();
      // 第三方
      if (obj.warehouseType === 2) {
        parameter = Object.assign({}, parameter, params);
      } else {
        parameter.carrierShippingMethodWarehouses = params.carrierShippingMethodWarehouses;
      }
      if (v.warehouseType === 'add') {
        url = api.post_ymsWarehouse;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else if (v.warehouseType === 'edit') {
        url = api.put_ymsWarehouse;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        parameter.ymsWarehouseId = v.ymsWarehouseId;
      }
      Promise.all(validateField.map(field => {
        const promise = new Promise(function (resolve, reject) {
          v.$refs['warehouseForm'].validateField(field, (error) => {
            resolve(error)
          })
        })
        return promise
      })).then((data) => {
        if (data.every(i => !i) && talg) {
          v.axios[method](url, parameter, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.warehouseModal = false;
              v.$Message.success(text);
              let data = response.data.datas;
              if (data) {
                data['carrierShippingMethodWarehouses'] = parameter.carrierShippingMethodWarehouses;
                data['carrierCode'] = parameter.carrierCode;
                v.$emit('updateWarehouseData', data);
              }
            }
          });
        }
      });
    },
    // 监听新增仓库的弹窗
    warehouseModalChange(value) {
      let v = this;
      if (!value) {
        v.$nextTick(() => {
          v.$refs['warehouseForm'].resetFields();
          v.$refs['overseasWarehouseConfig'].resetData();
        });
        v.allowCollectGoodsTalg = false;
        v.warehouseType = 'add';
        v.warehouseModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002414');
        v.ymsWarehouseId = null;
        v.layeredPriceList = [];
        v.senderAddressTemplateData = [];
        v.addressTemplateList = [];
        v.addressData.map((item) => {
          item.addressDetails = {};
        })
      }
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 新增地址模板
    addAddressTemplateBtn() {
      const {href} = this.$router.resolve({
        path: '/addressLibraryManage',
        query: {
          addressLibraryType: 'add'
        }
      });
      window.open(href, '_blank');
    },
    // 更新地址模板数据
    openChange(value) {
      if (value) {
        this.getAddressTemplateData().then((data) => {
          this.addressTemplateList = data;
          // 实时更新发货地址的基础数据
          let ymsDeliveryPlaceId = this.warehouseForm.ymsDeliveryPlaceId;
          let deliveryCountryList = [];
          if (ymsDeliveryPlaceId) {
            this.senderAddressTemplateData = [];
            this.placeOfShipmentList.map((item) => {
              if (item.ymsDeliveryPlaceId === ymsDeliveryPlaceId) {
                let ymsDeliveryPlaceCountryList = item.ymsDeliveryPlaceCountryList || [];
                deliveryCountryList = ymsDeliveryPlaceCountryList.map((item) => {
                  return item.deliveryCountry
                });
              }
            });
            this.addressTemplateList.map((item) => {
              if (deliveryCountryList.includes(item.countryCode)) {
                this.senderAddressTemplateData.push(item);
              }
            });
          }
        });
      }
    },
    // 选择地址模板
    selectChange(ymsAddressTemplateId, addressType) {
      if (this.addressTemplateList.length > 0) {
        let newList = this.addressTemplateList.filter((item) => {
          return item.ymsAddressTemplateId === ymsAddressTemplateId
        });
        if (newList && newList.length > 0) {
          this.addressData.map((ele) => {
            if (ele.addressType === addressType) {
              ele.addressDetails = newList[0];
              if (this.countrysOriginalData.length > 0) {
                this.countrysOriginalData.map((talg) => {
                  if (talg.twoCode === newList[0].countryCode) {
                    ele.addressDetails.countryCodeName = talg.cnName;
                  }
                })
              }
            }
          });
          this.$forceUpdate();
        }
      }
    },
    // 添加分层价
    addTieredPricingBtn() {
      let v = this;
      v.warehouseForm.packageHandlerCost = 0;
      setTimeout(() => {
        v.warehouseForm.packageHandlerCost = null;
      }, 500);
      let obj = {
        end: null,
        packageHandlerCost: null,
        start: null,
        type: 1,
        disabled: true,
        startErrorText: '',
        endErrorText: '',
        priceText: '',
        errorText: ''
      }
      if (v.layeredPriceList.length <= 0) {
        v.layeredPriceList.push({
          end: null,
          packageHandlerCost: null,
          start: null,
          type: 1,
          startErrorText: '',
          endErrorText: '',
          priceText: '',
          errorText: ''
        }, obj);
      } else {
        v.layeredPriceList.push(obj)
      }
      v.$forceUpdate();
    },
    // 删除分层价
    deleteLayeredPriceBtn(item, index) {
      let v = this;
      if (v.layeredPriceList.length <= 2) {
        v.layeredPriceList = [];
      } else {
        v.layeredPriceList.splice(index, 1);
        setTimeout(() => {
          v.layeredPriceList.map((ele, index) => {
            if (index > 0) {
              ele.start = v.layeredPriceList[index - 1].end + 1;
            }
          });
        }, 800);
        v.$forceUpdate();
      }
    },
    // 自动处理分层价的数据
    blurEndInput(item, index) {
      let v = this;
      let lastIndex = v.layeredPriceList.length - 1;
      if (index < lastIndex) {
        let value = item.end;
        if (value) {
          v.$set(v.layeredPriceList[index + 1], 'start', value + 1);
          v.$forceUpdate();
        }
      }
      v.verificationInterval(item, index, 'right');
    },
    // 校验左右区间大小的问题
    verificationInterval(item, index, type) {
      let v = this;
      let startVal = item.start;
      let endVal = item.end;
      let packageHandlerCostVal = item.packageHandlerCost;
      if (type === 'left') {
        if (isValueEmpty(startVal)) {
          v.$set(v.layeredPriceList[index], 'startErrorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002428'));
        } else {
          v.$set(v.layeredPriceList[index], 'startErrorText', '');
        }
      }
      if (type === 'right') {
        if (isValueEmpty(endVal)) {
          if (index !== this.layeredPriceList.length - 1) {
            v.$set(this.layeredPriceList[index], 'endErrorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002429'));
          }
        } else {
          v.$set(this.layeredPriceList[index], 'endErrorText', '');
        }
      }
      if (type === 'price') {
        if (isValueEmpty(packageHandlerCostVal)) {
          v.$set(this.layeredPriceList[index], 'priceText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002430'));
        } else {
          v.$set(this.layeredPriceList[index], 'priceText', '');
        }
      }
      if (startVal && endVal) {
        if (startVal >= endVal || endVal <= startVal) {
          v.$set(v.layeredPriceList[index], 'errorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002431'));
        } else {
          v.$set(v.layeredPriceList[index], 'errorText', '');
        }
      }
      v.$forceUpdate();
    },
    // 选择发货地
    warehouseDeliveryPlaceChange(value, collectionWarehouse, type) {
      this.senderAddressTemplateData = [];
      if (!type) {
        this.warehouseForm['sender'].ymsAddressTemplateId = null;
        this.addressData.map((item) => {
          if (item.addressType === 'sender') {
            item.addressDetails = {};
          }
        })
      }
      let list = this.placeOfShipmentList.filter((item) => {
        return item.ymsDeliveryPlaceId === value;
      });
      if (list.length > 0) {
        let allowCollectGoods = list[0].allowCollectGoods;
        let ymsDeliveryPlaceCountryList = list[0].ymsDeliveryPlaceCountryList.map((item) => {
          return item.deliveryCountry
        });
        this.addressTemplateList.map((item) => {
          if (ymsDeliveryPlaceCountryList.includes(item.countryCode)) {
            this.senderAddressTemplateData.push(item);
          }
        });
        this.allowCollectGoodsTalg = Number(allowCollectGoods) === 1;
      }
      this.warehouseForm.collectionWarehouse = this.warehouseType === 'add' ?
        (this.allowCollectGoodsTalg ? 1 : 0) : isValueEmpty(collectionWarehouse) ? 1 : collectionWarehouse;
    },
    // 获取服务商信息
    getCarrierInfo() {
      return new Promise((resolve) => {
        this.axios.get(api.get_carrier_getThirdCarriers).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            resolve(data)
          }
        });
      });
    },
  },
  components: {
    languagesTabs,
    overseasWarehouseConfigModule
  }
}
</script>

<style lang="less" scoped>
/deep/ .warehouseStyle {
  .title_box {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 0 16px;
    max-height: 680px;
    overflow-y: auto;

    .ivu-card-head {
      padding-left: 0;
    }

    .basic_item {
      line-height: inherit;

      .basic_title {
        min-width: initial;
      }

      .basic_txt {
        max-width: 260px;
      }
    }

    .errorTextBox {
      position: relative;

      .errorTxt {
        position: absolute;
        left: 0;
        bottom: -28px;
      }
    }

    .errorStyles {
      position: absolute;
      left: 0px;
      bottom: -30px;
    }

    .required_style_label {
      .ivu-input-number-handler-wrap {
        display: none;
      }
    }
  }
}
</style>